/**
 * External dependencies
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import Button from 'components/button';

/**
 * Style dependencies
 */
import './styles.scss';

const FormLabel = (props) => {
    return <label className={classNames(props.className, 'form-label')}>{props.children}</label>;
};

FormLabel.propTypes = {
    required: false,
};

export default FormLabel;
